<template>
  <v-navigation-drawer
      app
      clipped
      v-model="DRAWER_STATE"
      :width="sidebarWidth"
      :temporary="!$vuetify.breakpoint.xsOnly"
  >

    <v-list>
      <template v-for="(item, i) in checkRolesAndMain(items)">
        <!-- Header for section -->
        <v-row
            v-if="item.heading"
            :key="item.heading"
            align="center"
        >
          <v-col cols="6">
                        <span
                            style="padding-left: 32px"
                            class="text-body-1 subheader"
                            :class="(item.heading && DRAWER_STATE) ? 'show ' : 'hide'"
                        >
                            {{ item.heading }}
                        </span>
          </v-col>
          <v-col
              cols="6"
              class="text-center"
          >
          </v-col>
        </v-row>

        <!-- Divider -->
        <v-divider
            v-else-if="item.divider"
            :key="i"
            dark
            class="my-4"
        />

        <!-- If one item has child items -->
        <v-list-group
            color="primary"
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
        >
          <template v-slot:prependIcon>
            <v-icon size="24" class="mr-0" color="greyTint"> {{ item.icon }}</v-icon>
          </template>
          <template v-slot:activator>
            <v-list-item-content>
              <v-badge v-if="item.badge" content="New" color="secondary">
              </v-badge>
              <v-list-item-title>
                {{ $t('book/navbar:' + item.text) }}
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.route"
              link
              class="pl-12"
              @click="child.action ? child.action() : null"
          >
            <v-list-item-action class="mr-2" v-if="child.icon">
              <v-icon class="greyTint--text">{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('book/navbar:' + child.text) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <!-- Single item -->
        <v-list-item
            color="primary"
            v-else
            :key="item.text"
            :to="item.route === '#' ? '' : item.route"
            @click="item.action ? item.action() : null"
            link
        >
          <v-list-item-action class="mr-6">
            <v-icon
                :size="item.size ? item.size : 24"
                :color="item.color ? item.color : 'greyTint'"
            >{{ item.icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
                link
            >
              {{ $t('book/navbar:links.' + item.text) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import {Role} from "../../../core/data/roles";
import {mapActions, mapState} from 'vuex';
import store from '@/store';

const URL_PREFIX = '/' + store.state.manager.bookModuleUrl;

export default {
  props: {
    source: String,
  },
  name: 'SidebarComponent',
  data() {
    return {
      items: [
        {
          icon: 'dashboard',
          text: 'dashboard',
          route: URL_PREFIX + '/home',
          main: false,
          roles: [Role.Admin, Role.Operator, Role.Manager, Role.Worker]
        },
        {divider: true, roles: [Role.Admin, Role.Operator, Role.Manager, Role.Worker]},
        {
          icon: 'line_weight',
          text: 'processes',
          route: URL_PREFIX + '/processes',
          main: false,
          roles: [Role.Admin, Role.Operator, Role.Manager, Role.Worker]
        },
        {
          icon: 'apartment',
          text: 'buildings',
          route: URL_PREFIX + '/buildings',
          main: false,
          roles: [Role.Admin, Role.Operator]
        },
        {
          icon: 'business_center',
          text: 'facilities',
          route: URL_PREFIX + '/facilities',
          main: false,
          roles: [Role.Admin, Role.Operator, Role.Manager]
        },
        {divider: true, roles: [Role.Admin, Role.Operator, Role.Manager]},
        {
          icon: 'public',
          text: 'global-documentations',
          roles: [Role.Admin, Role.Operator, Role.Manager],
          model: false,
          children: [
            {text: 'global-docu-links.contracts', route: URL_PREFIX + '/global/contract', icon: 'receipt_long', main: false, roles: [Role.Admin, Role.Manager]},
            {text: 'global-docu-links.documentations', route: URL_PREFIX + '/global/documentation', icon: 'receipt_long', main: false, roles: [Role.Admin, Role.Manager]},
          ]
        },
        {divider: true, roles: [Role.Admin]},
        {
          icon: 'admin_panel_settings',
          roles: [Role.Admin],
          model: false,
          text: 'admin',
          children: [
            {
              icon: 'build',
              text: 'adminLinks.roles',
              route: URL_PREFIX + '/admin/worker-role',
              main: false
            },
            {
              icon: 'filter',
              text: 'adminLinks.parameter',
              route: URL_PREFIX + '/admin/parameter',
              main: false
            },
            {
              icon: 'line_weight',
              text: 'adminLinks.process',
              route: URL_PREFIX + '/admin/process/base',
              main: false
            },
            {
              icon: 'line_style',
              text: 'adminLinks.processSteps',
              route: URL_PREFIX + '/admin/process/steps',
              main: false
            },
            {
              icon: 'question_answer',
              text: 'adminLinks.processAnswers',
              route: URL_PREFIX + '/admin/process/answer',
              main: false
            },
            {
              icon: 'qr_code',
              text: 'adminLinks.qrcode',
              route: URL_PREFIX + '/admin/qrcode',
              main: false
            },
            {
              icon: 'import_export',
              text: 'adminLinks.import',
              route: URL_PREFIX + '/admin/import',
              main: false
            },
            {
              icon: 'storage',
              text: 'adminLinks.testdata',
              route: URL_PREFIX + '/admin/testdata',
              main: false
            }
          ]
        }
      ],
      sidebarWidth: 240,
      sidebarMinWidth: 96,
      dialog: false
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    isMain() {
      if (this.currentUser) {
        return this.currentUser.main;
      }
      return false;
    },
    ...mapState('book/layout', {
      drawer: state => state.drawer
    }),
    DRAWER_STATE: {
      get() {
        return this.drawer
      },
      set(newValue) {
        if (newValue === this.drawer) return;
        this.TOGGLE_DRAWER();
      }
    }
  },
  methods: {
    ...mapActions(
        'book/layout', ['TOGGLE_DRAWER']
    ),
    checkRolesAndMain: function (links) {
      var self = this;
      return links.filter(function (link) {
        return (!link.main || (link.main && self.isMain))
            && self.hasRole(link.roles);
      })
    },
    hasRole(roles) {
      if (this.currentUser && this.currentUser.roles) {
        for (let i = 0; i < roles.length; i++) {
          if (this.currentUser.roles.includes(roles[i])) {
            return true;
          }
        }
      }
      return false;
    }
  }
}
</script>

<style src="@/modules/core/components/Sidebar/Sidebar.scss" lang="scss"/>
